<template>
    <div class="leave">
        <div class="header" :style="cssVars">
            <div class="tabs" @click="chooseType('create')" :class="active === 'create' ? 'active' : ''">
                {{ $t("message") }}
            </div>
            <div class="tabs" @click="chooseType('list')" :class="active === 'list' ? 'active' : ''">
                {{ $t("leaveHis") }}
            </div>

            <i v-if="!isIframe" class="el-icon-back back" @click="back"></i>
            <i v-if="isIframe" class="el-icon-close backIframe" @click="backIframe"></i>
        </div>
        <div v-if="active === 'create'" class="main modal_body scroll_bar">
            <div class="top-tip-txt">
                <p>
                    {{ $t("txbj") }}
                </p>
            </div>
            <div v-if="initData.leaveMsgType == 2">
                <div class="form_item">
                    <div class="label">
                        <span class="red">*</span>
                        <span>{{ $t("leaveMsgCon") }}</span>
                    </div>
                    <el-input style="width: 100%" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }"
                              v-model="msgContent"
                              :placeholder="$t('pleInput')"/>
                </div>

                <div class="form_item">
                    <div class="label">
                        <span>{{ $t("attachments") }}</span>
                    </div>

                    <el-upload class="upload-demo" action="/api/chat/visitor/upload" :on-preview="handlePreview"
                               accept="image/gif,image/jpeg,image/png,image/jpg,image/bmp" :on-vwove="handlevwove"
                               :before-vwove="beforevwove" :on-success="getRes" :before-upload="checkFileExist"
                               :on-change="changeFile"
                               multiple :limit="3" :file-list="fileList">
                        <el-button size="small" type="text" class="uploadBtn">{{ $t("attachments") }}
                        </el-button>
                    </el-upload>
                </div>

                <el-form v-loading="!loadStatus" label-position="top" :inline="true" ref="woForm">
                    <div v-if="extendsField.length > 0">
                        <!-- 单行 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 1">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-input clearable v-model="item.chooseValue" style="width: 100%" type="text"
                                          :placeholder="$t('input')"/>
                            </div>
                        </div>

                        <!-- 多行 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 2">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-input clearable v-model="item.chooseValue" style="width: 100%" type="textarea"
                                          :placeholder="$t('input')"/>
                            </div>
                        </div>

                        <!-- 日期 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 3">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-date-picker v-model="item.chooseValue" type="date" style="width: 100%"
                                                value-format="yyyy-MM-dd"
                                                placeholder="请选择" align="right">
                                </el-date-picker>
                            </div>
                        </div>

                        <!-- 时间 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 4">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-date-picker style="width: 100%" type="datetime" v-model="item.chooseValue"
                                                format="yyyy-MM-dd HH:mm"
                                                placeholder="请选择" align="right">
                                </el-date-picker>
                            </div>
                        </div>

                        <!-- 数字 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 5">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-input-number clearable style="width: 100%" v-model="item.chooseValue"
                                                 type="textarea"
                                                 :placeholder="$t('input')"/>
                            </div>
                        </div>

                        <!-- 下拉 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 6">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-select style="width: 100%" :placeholder="$t('input')" v-model="item.chooseValue">
                                    <el-option v-for="val in item.fieldValue" :key="val.name" :label="val.name"
                                               :value="val.name"/>
                                </el-select>
                            </div>
                        </div>

                        <!-- 单选 -->
                        <div v-for="item in extendsField" :key="item.name" :label="item.name" :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 7">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-radio-group v-model="item.chooseValue">
                                    <el-radio v-for="val in item.fieldValue" :key="val.name" :label="val.name"
                                              :value="val.name"
                                              style="width: 100%">{{ val.name }}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <!-- 复选 -->
                        <div v-for="(item, index) in extendsField" :key="item.name" :label="item.name"
                             :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 8">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-checkbox-group @change="CheckChange(item, index)" v-model="item.chooseValue">
                                    <el-checkbox v-for="(val, index) in item.fieldValue" :key="index" :label="index"
                                                 style="width: 100%">
                                        {{ val.name }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>

                        <!-- 组合   -->
                        <div v-for="(item, index) in extendsField" :key="item.name" :label="item.name"
                             :value="item.name">
                            <div class="form_item" v-if="item.fieldType == 9">
                                <div class="label">
                                    <span v-if="item.requiredStatus" class="red">*</span>
                                    <span> {{ item.fieldName }}</span>
                                </div>
                                <el-cascader :options="item.fieldValue" :props="optionProps2" filterable ref="zdy"
                                             @change="formFieldchange(item, index)">
                                </el-cascader>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-if="initData.leaveMsgType == 1">
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t('userName') }}</span>
                    </div>
                    <el-input v-model="customerName" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userPhone') }}</span>
                    </div>
                    <el-input v-model="customerPhone" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span>{{ $t('userEmail') }}</span>
                    </div>
                    <el-input v-model="customerEmail" type="text" :placeholder="$t('input')"/>
                </div>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t('leaveMsgCon') }}</span>
                    </div>
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-model="msgContent"
                              :placeholder="$t('pleInput')"/>
                </div>

            </div>
            <el-button :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" class="submitBtn"
                       type="primary" @click="sendMessage">
                {{ $t("submitLeave") }}
            </el-button>
        </div>

        <div v-if="active === 'list'" class="modal_body scroll_bar">
            <div v-if="initData.leaveMsgType == 2">
                <div v-if="!showFlag" @click="showDetail(item)" class="leave_msg_item" v-for="item in list"
                     :key="item.id">
                    <div>
                        <span class="time">{{ formDate(item.createTime) }}</span>
                        <span class="woStatus" :class="
            item.woStatus == 0
              ? 'redFont'
              : item.woStatus == 1
                ? 'yellow'
                : item.woStatus == 2
                  ? 'blue'
                  : 'green'
          ">
            {{ workOrderStateList[item.woStatus] }}</span>
                    </div>
                    <div>
                        <span>{{ item.woContent }}</span>
                    </div>
                </div>
                <div v-if="0">
                    <el-steps direction="vertical" class="scroll_bar h300">
                        <el-step v-for="item in orderDetail.handle" :key="'step' + item.handleTime">
                            <template slot="icon">
                                <span class="bg"></span>
                            </template>
                            <template slot="title">
                                <div class="pannel his_title">
                <span v-if="item.handleUserName" class="name sub">{{
                        item.handleUserName == "customer" ? $t("client") : $t("customer")
                    }}</span>
                                    <span v-if="!item.handleUserName" class="name sub">{{
                                            $t("client")
                                        }}</span>

                                    <span class="time sub sub_title">{{ formDate(item.handleTime) }}</span>
                                </div>
                            </template>
                            <template slot="description">
                                <div class="his_item">
                                    <div class="pannel">
                                        <span class="sub2">{{ $t("orderPriority") }}:</span>
                                        <span> {{ levelLists[item.handleWoLevel] }}</span>
                                    </div>
                                    <div class="pannel">
                                        <span class="titl">{{ $t("orderStatus") }}:</span>
                                        <span> {{ workOrderStateList[item.handleWoStatus] }}</span>
                                    </div>
                                    <div class="pannel">
                                        <span class="titl fl">{{ $t("reply") }}:</span>
                                        <span class="qp" v-html="item.handleContent"></span>
                                    </div>
                                </div>
                            </template>
                        </el-step>
                    </el-steps>

                    <div class="form_item">
                        <div>
                            <span class="red">*</span>
                            <span>{{ $t("reply") }}</span>
                        </div>
                        <el-input type="textarea" v-model="msgContent" :placeholder="$t('pleInput')"/>
                    </div>

                    <div class="form_item">
                        <div>
                            <span>{{ $t("attachments") }}</span>
                        </div>
                        <el-upload class="upload-demo" action="/api/chat/visitor/upload" :on-preview="handlePreview"
                                   accept="image/gif,image/jpeg,image/png,image/jpg,image/bmp" :on-vwove="handlevwove"
                                   :before-vwove="beforevwove" :on-success="getRes" :before-upload="checkFileExist"
                                   :on-change="changeFile"
                                   multiple :limit="3" :file-list="fileList">
                            <el-button size="small" type="text" class="uploadBtn">{{ $t("attachments") }}
                            </el-button>
                        </el-upload>
                    </div>
                    <button :style="{ backgroundColor: initData.kitBgcolor }" @click="addWoHandleInfo">
                        {{ $t("submitLeave") }}
                    </button>
                </div>
            </div>

            <div v-if="initData.leaveMsgType == 1">
                <div class="leave_msg_item" v-for="item in leavelist">
                    <div>
                        <span class="label">{{ $t('messageName') }}：</span>
                        <span>{{ item.customerName }}</span>
                    </div>
                  <div>
                    <span class="label">{{ $t('messageName') }}：</span>
                        <span>{{ item.customerName }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageEmail') }}：</span>
                        <span>{{ item.customerEmail }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messagePhone') }}：</span>
                        <span>{{ item.customerPhone }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageContent') }}：</span>
                        <span>{{ item.msgContent }}</span>
                    </div>
                    <div>
                        <span class="label">{{ $t('messageSubmitTime') }}：</span>
                        <span>{{ formDate(item.createTime) }}</span>
                    </div>
                    <div>
                    <span class="label">{{ $t('messageStatus') }}：</span>
                    <span>{{item.msgState == 1 ? $t('haveDeal'): $t('noDeal')}}</span>
                    </div>
                    <div v-if="item.updateTime">
                    <span class="label">{{ $t('messageDealTime') }}：</span>
                    <span>{{formDate(item.updateTime) }}</span>
                    </div>
                  <div v-if="item.msgDesc">
                    <span class="label">{{ $t('remark') }}：</span>
                    <span>{{item.msgDesc }}</span>
                  </div>

<!--                    <div v-if="item.updateUserName">-->
<!--                        <span class="label">处理时间：</span>-->
<!--                        <span>{{ formDate(item.updateUserName) }}</span>-->
<!--                    </div>-->
                    </div>
                </div>

        </div>

        <el-drawer :append-to-body="true" :modal-append-to-body="false" :transfer="false" class="drawer" size="100%"
                   direction="rtl" :title="$t('leaveMsg')" :visible.sync="showFlag">
            <div class="card-content scroll_bar" id="iii">
                <v-loading v-if="hide"></v-loading>
                <div class="detailTime-style">
                    <el-timeline>
                        <el-timeline-item size="large" class="fir"><br/></el-timeline-item>
                        <el-timeline-item v-for="(item, index) in orderDetail.handle" :key="index" :icon="item.icon"
                                          :type="item.type" :size="item.size">
                            <div class="companydel">
                                <span class="time sub sub_title">{{ formDate(item.handleTime) }}</span>
                            </div>
                            <div class="contentdel">
                                <div class="pannel">
                  <span v-if="item.handleUserName" class="name sub">{{
                          item.handleUserName == "customer" ? $t("client") : $t("customer")
                      }}</span>
                                    <span v-if="!item.handleUserName" class="name sub">{{
                                            $t("client")
                                        }}</span>
                                </div>
                                <div class="pannel">
                                    <span class="titl">{{ $t("orderStatus") }}:</span>
                                    <span> {{ workOrderStateList[item.handleWoStatus] }}</span>
                                </div>
                                <div class="pannel">
                                    <span class="titl fl">{{ $t("reply") }}:</span>
                                    <span class="qp" v-html="item.handleContent"></span>
                                </div>
                                <div class="pannel" v-if="item.woFileVoList && item.woFileVoList.length > 0">
                                    <span class="titl fl">{{ $t("attachments") }}:</span>
                                    <span v-for="(it, index) in item.woFileVoList" :key="index">
                    <a class="link" target="_blank" :href="it.fileUrl">{{ it.fileName }}
                    </a>
                  </span>
                                </div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>

            <div class="bottomBtn">
                <el-button :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" class="submitBtn"
                           type="primary" @click="showReply = true">
                    {{ $t("reply") }}
                </el-button>
            </div>
        </el-drawer>
        <el-dialog width="80%" class="dialog" :append-to-body="false" :visible.sync="showReply"
                   :close-on-click-modal="true"
                   :title="$t('reply')">
            <div>
                <div class="form_item">
                    <div>
                        <span class="red">*</span>
                        <span>{{ $t("reply") }}</span>
                    </div>
                    <el-input type="textarea" style="width: 100%" v-model="msgContent" :placeholder="$t('pleInput')"
                              :autosize="{ minRows: 5, maxRows: 5 }"/>
                </div>

                <div class="form_item">
                    <div>
                        <span>{{ $t("attachments") }}</span>
                    </div>

                    <el-upload class="upload-demo" action="/api/chat/visitor/upload" :on-preview="handlePreview"
                               accept="image/gif,image/jpeg,image/png,image/jpg,image/bmp" :on-vwove="handlevwove"
                               :before-vwove="beforevwove" :on-success="getRes" :before-upload="checkFileExist"
                               :on-change="changeFile"
                               multiple :limit="3" :file-list="fileList">
                        <el-button size="small" type="text" class="uploadBtn">{{ $t("attachments") }}
                        </el-button>
                    </el-upload>
                </div>
                <el-button :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }" class="submitBtn"
                           type="primary" @click="addWoHandleInfo">
                    {{ $t("reply") }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {Toast} from "mint-ui";
import store from "../../store/index";

import urlParams from "../../api/urlParams";
import request from "../../api/request";
import chatApi from "../methods";

export default {
    name: "pc",
    data() {
        return {
            isIframe: false,
            active: "create",
            fileList: [],
            email: "",
            loadStatus: false,
            showReply: false,
            hide: false,
            LeaveMsgF: false,
            list: [],
            extendsField: [],
            Field: [],
            chooseList: [],

            optionProps2: {
                value: "id",
                label: "name",
                children: "children",
            },
            showFlag: false,
            orderDetail: {},
            levelLists: {
                0: this.$t("orderLow"),
                1: this.$t("orderNormal"),
                2: this.$t("orderWarning"),
                3: this.$t("orderDanger"),
            },
            workOrderStateList: {
                99: this.$t("orderOver"),
                0: this.$t("orderNoYet"),
                1: this.$t("orderAccept"),
                2: this.$t("orderWait"),
                3: this.$t("orderResolved"),
                5: this.$t("orderOver"),
            },
            typeId: "",
            typeName: "",
            mainColor: '',
            cusColor: '',
            sideShow: false,
            msgContent: '',
            customerEmail: '',
            customerName: '',
            customerPhone: '',
            leavelist: []
        };
    },
    watch: {
        initData() {

            return this.$store.state.initData;
        },
        connectStatus() {
            return this.$store.state.connectStatus
        }
    },
    computed: {
        initData() {
            this.mainColor = this.$store.state.initData.mainColor;
            this.cusColor = this.$store.state.initData.cusColor;
            if (this.$store.state.initData.sideBarStatus && this.$store.state.initData.sideBarList.length > 0) {
                this.sideShow = true;
            }
            return this.$store.state.initData;
        },
        customer() {
            return this.$store.state.customer;
        },
        connectStatus() {
            return this.$store.state.connectStatus
        },
        cssVars() {
            return {
                "--cusColor": this.cusColor
            };
        }
    },
    mounted() {
        if (urlParams("from") === "iframe") {
            this.isIframe = true;
        }
        setTimeout(() => {
            this.getTemplateFiled();
        }, 1000);
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return "--";
            }
            fmt = fmt || "yyyy-MM-dd hh:mm:ss";
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                "M+": getDate.getMonth() + 1,
                "d+": getDate.getDate(),
                "h+": getDate.getHours(),
                "m+": getDate.getMinutes(),
                "s+": getDate.getSeconds(),
                "q+": Math.floor((getDate.getMonth() + 3) / 3),
                S: getDate.getMilliseconds(),
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                    );
                }
            }
            return fmt;
        },
        chooseType(type) {
            this.active = type;

            this.showFlag = false;
            this.msgContent = [];
            this.fileList = [];
            this.activeType = type;
            if (type === "list") {
                this.getLeaveMsg();
            }
        },
        back() {
            this.$router.push(
                "/index" + "?channelId=" + this.$route.query.channelId
            );
        },
        backIframe() {
            this.$router.push(
                "/index" +
                "?channelId=" +
                this.$route.query.channelId +
                "&from=iframe&random" +
                Math.random()
            );
        },
        getLeaveMsg() {
            this.msgContent = [];
            this.fileList = [];
            if (this.initData.leaveMsgType == 2) {
                request
                    .queryWoByCustom({
                        userId: store.state.userInfo.userId || urlParams("userId"),
                        tenantId: store.state.initData.tenantId || urlParams("tenantId"),
                    })
                    .then((res) => {
                        this.list = res.data.list;
                    });
            } else {
                chatApi.getLeaveMsg((result) => {
                    this.leavelist = result.data;
                })
            }
        },

        showDetail(item) {
            this.showFlag = true;

            request
                .woinfo({
                    id: item.woId,
                })
                .then((res) => {
                    console.log(res);
                    this.orderDetail = res.data;
                });
        },
        getRes(res) {
            console.log(res);
        },
        changeFile(file, fileList) {
            this.fileList = fileList;
        },
        handlevwove(file, fileList) {
            console.log(fileList);
            this.fileList = fileList;
        },
        handlePreview(file) {
            console.log(file);
        },
        checkFileExist(file, fileList) {
            console.log(file);
            const files = file; //获取文件
            let Arr = [
                ".rar",
                ".zip",
                ".tar",
                ".gz",
                ".7z",
                ".bz2",
                ".cab",
                ".iso",
                ".doc",
                ".docx",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx",
                ".pdf",
                ".txt",
                ".md",
                ".xml",
                ".txt",
            ];
            let fileName = files.name;
            let fileIndex = fileName.lastIndexOf(".");
            let substrName = fileName.substr(fileIndex);
            if (Arr.indexOf(substrName) > -1) {
                this.$message({
                    type: "error",
                    message: this.$t("onlyIMG"),
                });
                file.target.value = null;
                return;
            }
            if (file.size > 5242880 * 2) {
                Message({
                    message: window.vm.$i18n.t("fileMax"),
                    type: "error",
                });
                return;
            }
            const obj = {
                file: files,
                userId: store.state.userInfo.userId || urlParams("userId"),
            };
            this.fileList = [];
            request.uploadFile(obj).then((result) => {
                if (result.code === 200) {
                    console.log(result, "fj");
                    this.fileList.push(result.data);
                }
            });
        },

        beforevwove(file, fileList) {
            return this.$confirm("delete" + ` ${file.name}？`);
        },
        addWoHandleInfo() {
            var param = {
                userId: store.state.userInfo.userId || urlParams("userId"),
                tenantId: store.state.initData.tenantId || urlParams("tenantId"),
                woId: this.orderDetail.woId,
                handleContent: this.msgContent,
                woFileRelVoList: [],
                woTypeId: this.typeId,
            };
            if (this.fileList.length > 0) {
                for (let i = 0; i < this.fileList.length; i++) {
                    param.woFileRelVoList.push({
                        fileName: this.fileList[i].name,
                        fileType: this.fileList[i].suffix,
                        fileUrl: this.fileList[i].url,
                    });
                }
            }

            request.addWoHandleInfo(param).then((res) => {
                Toast({
                    message: this.$t("submitSuc"),
                    duration: 2000,
                });
                console.log(res);
                this.showReply = false;
                this.showDetail({
                    woId: this.orderDetail.woId,
                });
            });
        },
        // 发送留言
        sendMessage() {

            if (this.initData.leaveMsgType == 2) {
                var param = {
                    cusFieldConfigInfoVoList: [],
                    partnerId: "",
                    userId: store.state.userInfo.userId || urlParams("userId"),
                    tenantId: store.state.initData.tenantId || urlParams("tenantId"),
                    woContent: this.msgContent,
                    woFileRelVoList: [],
                    woStartWay: 0,
                    woTitle: "留言工单",
                    woType: "",
                    woTypeId: this.typeId,
                    woTypeName: this.typeName,
                };
                if (this.msgContent.trim() == "") {
                    Toast({
                        message: this.$t("pleInput") + this.$t("leaveMsgCon"),
                        duration: 3000,
                    });
                    return;
                }
                if (this.fileList.length > 0) {
                    for (let i = 0; i < this.fileList.length; i++) {
                        param.woFileRelVoList.push({
                            fileName: this.fileList[i].name,
                            fileType: this.fileList[i].suffix,
                            fileUrl: this.fileList[i].url,
                        });
                    }
                }
                if (this.extendsField.length > 0) {
                    for (let i = 0; i < this.extendsField.length; i++) {
                        if (
                            this.extendsField[i].requiredStatus &&
                            this.extendsField[i].chooseValue == ""
                        ) {
                            // 必填评价
                            Toast({
                                message: this.$t("pleInput") + this.extendsField[i].fieldName,
                                duration: 3000,
                            });
                            return;
                        }
                        if (this.extendsField[i].fieldType == 8) {
                            param.cusFieldConfigInfoVoList.push({
                                fieldId: this.extendsField[i].fieldId,
                                fieldValue: this.extendsField[i].chooseName.join(","),
                                fieldName: this.extendsField[i].fieldName,
                            });
                        } else {
                            param.cusFieldConfigInfoVoList.push({
                                fieldId: this.extendsField[i].fieldId,
                                fieldValue: this.extendsField[i].chooseValue,
                                fieldName: this.extendsField[i].fieldName,
                            });
                        }
                    }
                }

                request.addWo(param).then((res) => {
                    Toast({
                        message: this.$t("submitSuc"),
                        duration: 2000,
                    });
                    this.active = "list";
                    this.chooseType(this.active);
                    this.extendsField.forEach((item) => {
                        if (item.fieldType == 8) {
                            item.chooseValue = [];
                        } else {
                            item.chooseValue = "";
                        }
                    });
                });
            } else {
                var param = {
                    "customerEmail": this.customerEmail,
                    "customerName": this.customerName,
                    "customerPhone": this.customerPhone,
                    "msgContent": this.msgContent,
                    channelId: this.initData.channelId,
                }
                chatApi.submitMessage(param, () => {
                    this.customerEmail = '';
                    this.customerName = '';
                    this.customerPhone = '';
                    this.msgContent = '';
                    store.dispatch('setConfigPc', [{key: 'showModal', value: false}, {
                        key: 'messageModal',
                        value: false
                    }])
                })
            }

        },
        getTemplateFiled() {
            if (this.$store.state.initData.leaveMsgWoType) {
                request
                    .getTemplateFiledInfoByTypeId({
                        // tenantId: store.state.initData.tenantId || urlParams("tenantId"),
                        // locale: locale == "vi" ? "vi" : "zh",
                        id: this.$store.state.initData.leaveMsgWoType
                    })
                    .then((res) => {
                        this.loadStatus = true;
                        this.typeId = res.data.woType.typeId;
                        this.typeName = res.data.woType.typeName;
                        this.extendsField = [];
                        this.Field = res.data.items;
                        this.Field.forEach((item) => {
                            if (item.fieldValue) {
                                item.fieldValue = JSON.parse(item.fieldValue);
                            }
                        });
                        for (let i = 0; i < this.Field.length; i++) {
                            if (this.Field[i].fieldType == 8) {
                                this.extendsField.push({
                                    fieldId: this.Field[i].fieldId,
                                    fieldName: this.Field[i].fieldName,
                                    fieldType: this.Field[i].fieldType,
                                    fieldValue: this.Field[i].fieldValue,
                                    chooseValue: [],
                                    chooseName: [],
                                    requiredStatus: this.Field[i].requiredStatus,
                                });
                            } else {
                                this.extendsField.push({
                                    fieldId: this.Field[i].fieldId,
                                    fieldName: this.Field[i].fieldName,
                                    fieldType: this.Field[i].fieldType,
                                    fieldValue: this.Field[i].fieldValue,
                                    chooseValue: "",
                                    requiredStatus: this.Field[i].requiredStatus,
                                });
                            }
                        }
                    });
            }
        }
    },
};
</script>

<style scoped>
.leave {
    width: 100%;
    height: 100%;
    background: #fff;
}

.header {
    display: flex;
    font-size: 14px;
}

.header > div {
    flex: 1;
    line-height: 20px;
    padding: 10px;
    margin: 0 20px;
}

.tabs.active {
    color: var(--cusColor);
    border-bottom: 3px solid var(--cusColor);
}

.main {
    padding: 15px;
}

.tips {
    color: gainsboro;
    font-size: 13px;
    text-align: left;
}

strong {
    color: red;
}

.items {
    text-align: left;
}

.items .label {
    font-size: 14px;
    color: #5a5a5a;
    line-height: 28px;
    text-align: left;
    margin-bottom: 10px;
}

.top-tip-txt {
    margin: 0 auto;
    padding: 12px 20px;
    color: #acb5c4;
    word-break: break-word;
    display: block;
    width: 80%;
}

.top-tip-txt p {
    margin-bottom: 0;
    word-break: break-word;
    font-size: 13px;
    text-align: left;
}

.modal_body {
    padding: 20px 10px 20px 15px;
    flex: 1;
    height: 94vh;
    max-height: 94vh;
    box-sizing: border-box;
}

.modal_body > p {
    margin-top: 0;
    font-size: 14px;
}

.form_item > div {
    display: block;
    /* width: 80px; */
    vertical-align: middle;
    color: #666666;
}

.form_item {
    display: block;
    align-items: center;
    margin: 15px auto;
    width: 80%;
    text-align: left;
}

.label {
    margin-bottom: 10px;
    font-size: 14px;
}

.form_item .el-input,
.form_item .el-textarea {
    flex: 1;
    font-size: 14px;
    vertical-align: middle;
    color: #535151;
    outline: none;
}

textarea {
    flex: 1;
    resize: none;
    height: 42px;
    width: 440px;
    vertical-align: text-top;
    padding: 8px;
    border: 1px solid #e6e6e6;
    outline: none;
    color: #535151;
}

button {
    width: 180px;
    height: 32px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}

.uploadBtn {
    width: 80px;
    height: 27px;
    color: #66b1ff;
    border-radius: 4px;
    cursor: pointer;
    border: none;
    margin: 0;
    text-align: left;
}

div.row {
    width: 100%;
    max-width: 410px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.row .item {
    flex: 1;
    margin: 10px 5px;
    border-radius: 4px;
    cursor: pointer;
}

.row .item.active {
    color: white;
    border: none;
}

.noData {
    height: 20px;
}

button {
    margin-top: 20px;
}

.manual {
    min-height: 200px;
}

.manual .star {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-image: url("../../../static/image/star.png");
    background-size: 100% 100%;
    cursor: pointer;
}

.manual .star.active {
    background-image: url("../../../static/image/starActive.png");
}

.manual p {
    font-size: 14px;
    color: #7467f0;
    margin: 15px;
}

.leave_msg_item {
    padding: 20px 14px;
    cursor: pointer;
    border-radius: 3px;
    background: #fff;
    width: 80%;
    margin: 10px auto;
}

.leave_msg_item:hover {
    border: 1px solid #f7f9fc;
    background-color: #f7f9fc;
}

.leave_msg_item div {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0;
    color: #a1a7b3;
}

.leave_msg_item .label {
    width: 100px;
    display: inline-block;
    text-align: right;
    padding-left: 3px;
    color: #666;
}

.leave_msg_item .time {
    width: 216px;
    display: inline-block;
    text-align: left;
    color: #3d424d;
    font-weight: 600;
}

.leave_msg_item .woStatus {
    float: right;
    display: block;
    color: #fff;
    width: 80px;
    text-align: center;
    border-radius: 3px;
    background: #e4eaf2;
}

.leave_msg_item .label + span {
    width: 60px;
}

.file {
    width: 70px;
    position: relative;
}

.file a {
    position: absolute;
    left: 26px;
    line-height: 26px;
    color: #fff;
}

.file input {
    opacity: 0;
}

.el-steps--vertical {
    height: auto;
}

.h300 {
    overflow-y: scroll;
    height: 300px;
}

.bottomBtn {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 100%;
    text-align: center;
    background: #f5f9fa;
}

.submitBtn {
    display: block;
    width: 90%;
    height: 44px;
    font-weight: 700;
    color: #fff;
    background: var(--theme-color);
    border: none;
    border-radius: 40px;
    font-size: 17px;
    margin: 10px auto;
}

.card-content .detailTime-style {
    position: absolute;
    left: 30px;
    top: 5px;
    height: 300px;
}

.el-timeline .fir .el-timeline-item__node {
    background-color: white;
    border: 1px #e4e7f0 solid;
}

.el-timeline .las .el-timeline-item__node {
    background-color: white;
    border: 1px #e4e7f0 solid;
}

.companydel {
    color: #6f6f6f;
    position: absolute;
    width: 100px;
    font-size: 12px;
    left: -100px;
}

.contentdel {
    position: relative;
    padding: 10px;
    top: -10px;
    border: 1px solid #e4e7f0;
    border-radius: 8px;
    font-size: 12px;
    color: #6f6f6f;
}

.statusfalse {
    background-color: #3d87f2;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    padding: 2px 5px;
}

.statustrue {
    background-color: #dc4e47;
    text-align: center;
    color: #fff;
    border-radius: 6px;
    padding: 2px 5px;
}

.contentdel::before {
    position: absolute;
    top: 34px;
    left: -10px;
    top: 15px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 10px solid #e4e7f0;
    content: "";
}

.fr {
    float: right;
}

.contentdel::after {
    position: absolute;
    top: 34px;
    left: -8px;
    top: 15px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 10px solid #fff;
    content: "";
}

.card-content .loadmore-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    padding: 20px 0;
}

.card-content .load-style {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(#000, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-content .nodata-con {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-content {
    height: 100%;
    overflow: auto;
    position: relative;
}

.el-timeline {
    margin-left: 100px;
}

.pannel {
    max-width: 400px;
}

.back {
    position: absolute;
    left: 8px;
    cursor: pointer;
    line-height: 40px;
    font-size: 20px;
}

.backIframe {
    position: absolute;
    right: 8px;
    cursor: pointer;
    line-height: 36px;
    font-size: 16px;
}

.yellow {
    background: #fff8e6 !important;
    border-color: #fff1cc;
    color: #ffba00 !important;
}

.green {
    background: #e7faf0 !important;
    border-color: #d0f5e0;
    color: #13ce66 !important;
}

.blue {
    background: #ebf2ff !important;
    border-color: #d6e5ff;
    color: #347dff !important;
}

.redFont {
    background-color: #ffeded !important;
    border-color: #ffdbdb;
    color: #ff4949 !important;
}

.link {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/leaveMsg/h5.vue